import QRCode from 'qrcode';
import JSZip from 'jszip';
import axios from 'axios';
import Web3 from 'web3';

const web3 = new Web3(process.env.VUE_APP_WEB3_PROVIDER);

let chainId = process.env.VUE_APP_CHAIN_ID;
function BadgeBot(apiKey, apiUrl = null) {
  // Default configuration
  const config = {
    apiKey,
    apiUrl:
      apiUrl ||
      process.env.VUE_APP_STUDIO_API_URL ||
      'https://api.studio.mydid.com/api/v1/sessions',
    resolverUrl:
      process.env.VUE_APP_RESOLVER_URL ||
      'https://resolver.mydid.eu/1.0/identifiers',
  };

  //"apiKey": "785e3a8c66ad6e87c29b118ed4a86016ab50d244a892e8ea80fffcc35c133fac"
  //Mywlecome badge

  const createTemplate = async () => {
    const url = `${config.apiUrl}/builders/create`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          apiKey: config.apiKey,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Create Template Error:', error.message);
      return false;
    }
  };

  const getTemplate = async () => {
    const url = `${config.apiUrl}/builders/template/${config.apiKey}`;

    try {
      const response = await axios.get(url);
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.data;
    } catch (error) {
      console.error('Get Template Error:', error.message);
      throw error;
    }
  };

  const getTemplateStatus = async () => {
    try {
      const createResponse = await createTemplate();

      if (!createResponse) {
        throw new Error('Failed to create template');
      }

      let responseData;
      if (typeof createResponse === 'object') {
        responseData = createResponse;
      } else {
        responseData = JSON.parse(createResponse);
      }

      if (!responseData.links || !responseData.links[0]) {
        throw new Error('No link found in response');
      }

      const code = responseData.links[0].split('/').pop();
      const url = `${config.apiUrl}/status/${code}`;

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Get Template Status Error:', error.message);
      throw error;
    }
  };

  const getIssuerDetailsLinkFromCode = async (did) => {
    const url = `${config.resolverUrl}/${did}?chainId=${chainId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Get Issuer Details Error:', error.message);
      throw error;
    }
  };

  const getJsonDataFromUrl = async (url) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Failed to get contents from URL: ${url}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Get JSON Data Error:', error.message);
      throw error;
    }
  };

  const getLinkStatus = async (link) => {
    console.log('link', link);
    const code = link.split('/').pop();
    const url = `${config.apiUrl}/status/${code}`;
    const response = await fetch(url);
    return await response.json();
  };

  const generateLinks = async (quantity) => {
    const links = [];
    for (let i = 0; i < quantity; i++) {
      const template = await createTemplate();
      if (!template || !template.links) {
        return next(new AppError('Error creating template', 500));
      }
      links.push({
        link: template.links[0],
        status: 'pending',
      });
    }
    return links;
  };

  return {
    createTemplate,
    getTemplate,
    getTemplateStatus,
    getIssuerDetailsLinkFromCode,
    getJsonDataFromUrl,
    getLinkStatus,
    generateLinks,
  };
}

export async function generateQRCode(link) {
  return await QRCode.toDataURL(link);
}

export async function generateZip(links) {
  const zip = new JSZip();
  for (const link of links) {
    const qrCodeDataUrl = await QRCode.toDataURL(link.link);
    const qrCodeBlob = await (await fetch(qrCodeDataUrl)).blob();
    zip.file(`${link.link}.png`, qrCodeBlob);
  }
  const zipBlob = await zip.generateAsync({ type: 'blob' });
  return zipBlob;
}

export async function generateCsv(links) {
  const csv = links.map((link) => link.link).join('\n');
  return new Blob([csv], { type: 'text/csv' });
}

export function downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function getJsonDataFromUrl(url) {
  if (
    !url.startsWith('https://myntfsid.mypinata.cloud/') &&
    !url.startsWith('https://resolver.mydid.eu/')
  )
    throw 'Bad URL input for method : getJsonDataFromUrl';
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(function (response) {
        return response.arrayBuffer();
      })
      .then(function (buffer) {
        const decoder = new TextDecoder('utf-8');
        const text = decoder.decode(buffer);
        resolve(JSON.parse(text));
      })
      .catch((err) => {
        if (!url.startsWith('https://myntfsid.mypinata.cloud/')) reject(err);

        // retry with secondary ipfs gateway
        fetch(
          url.replace('https://myntfsid.mypinata.cloud/', 'https://ipfs.io/')
        )
          .then(function (response) {
            return response.arrayBuffer();
          })
          .then(function (buffer) {
            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(buffer);
            resolve(JSON.parse(text));
          })
          .catch((err) => {
            reject(err);
          });
      });
  });
}

export async function getJsonDataFromCID(cid) {
  return new Promise((resolve, reject) => {
    fetch('https://myntfsid.mypinata.cloud/ipfs/' + cid)
      .then(function (response) {
        return response.arrayBuffer();
      })
      .then(function (buffer) {
        const decoder = new TextDecoder('utf-8');
        const text = decoder.decode(buffer);
        resolve(JSON.parse(text));
      })
      .catch((err) => {
        // retry with secondary ipfs gateway
        fetch('https://myntfsid.mypinata.cloud/ipfs/' + cid)
          .then(function (response) {
            return response.arrayBuffer();
          })
          .then(function (buffer) {
            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(buffer);
            resolve(JSON.parse(text));
          })
          .catch((err) => {
            reject(err);
          });
      });
  });
}

export function templateTypeToLabel(type, i18n, short) {
  switch (type) {
    case 'Basic':
      return 'Certified';
    case 'Community':
      return 'Peer-to-peer';
    case 'Participation':
      return 'Participation';
    case 'Membership':
      return 'Community';
    case 'Ticket':
      return 'Ticket';
    case 'Role':
      return 'Role';
  }
}

export default {
  async install(app) {
    const utils = {
      generateQRCode,
      generateZip,
      generateCsv,
      downloadFile,
      BadgeBot,
      getJsonDataFromUrl,
      getJsonDataFromCID,
      templateTypeToLabel,
    };
    app.provide('utils', utils);
  },
};
